import api from 'apis/config/api-service';
import { toCmsListQuery } from 'apis/config/legacy-table-query';

interface Supplier {
  id: string | number;
  [key: string]: any;
}

interface SupplierParams {
  [key: string]: any;
}

interface SupplierUser {
  id: string | number;
  [key: string]: any;
}

const cmsSuppliers = 'api/v1/cms/suppliers';
// qsupply/backend wraps single resources in { data }; the legacy Redux actions expect the bare object.
const unwrap = (body: { data: any }) => body.data;

export default {
  // `join` is ignored: categories always come with each supplier.
  getSuppliers: (params?: SupplierParams) => api.get(cmsSuppliers, { params: toCmsListQuery(params) }),
  getSupplierById: (id: string | number) => api.get(`${cmsSuppliers}/${id}`),
  updateSupplier: (supplier: Supplier) => api.patch(`${cmsSuppliers}/${supplier.id}`, supplier).then(unwrap),
  createSupplier: (body: SupplierParams) => api.post(cmsSuppliers, body).then(unwrap),
  getSupplierUsers: (id: string | number, params?: SupplierParams) =>
    api.get(`${cmsSuppliers}/${id}/users`, { params: toCmsListQuery(params) }),
  getSupplierUserById: (userId: string | number) => api.get(`${cmsSuppliers}/users/${userId}`),
  updateSupplierUser: (user: SupplierUser) => api.patch(`${cmsSuppliers}/users/${user.id}`, user).then(unwrap),
};
